module.exports = ".required {\n    color: red;\n}\n.hidden {\n    display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/product-data/product-groups/edit/product-group-edit.component.css
// module id = ./src/app/agora/components/product-data/product-groups/edit/product-group-edit.component.css
// module chunks = main